import { defineComponent as _defineComponent } from 'vue'
import { useModuleStore } from '@/helpers/composables/useStores';
import { ModalHelper } from '@/helpers/modal-helper';
import ReelModal from '@/components/experiments/ReelsExp/components/ReelModal.vue';
import { MovieOrShow } from '@/@types/graphql-types';
import { ref } from 'vue';
import HLSPlayer from '@/components/experiments/ReelsExp/components/HLSPlayer.vue';
import { GetPopularTitlesQueryVariables } from '@/pages/graphql/queries/GetPopularTitles.query';
import { getClipFromMovieOrShow } from '@/components/experiments/ReelsExp/components/query';

import ReelsExp from '../index';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReelDesktopOverlay',
  props: {
    queryVariables: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
	queryVariables: GetPopularTitlesQueryVariables;
	title: MovieOrShow;
};

const { setActiveModuleIndex } = useModuleStore();



const clipUrl = getClipFromMovieOrShow(props.title);

const expanded = ref(false);

// Event Handlers
function toggleExpand(evt: Event) {
	expanded.value = !expanded.value;
}

function collapse() {
	expanded.value = false;
	setActiveModuleIndex(null);
}

function handleClick() {
	ReelsExp.trackEvent({
		action: 'click',
		label: 'video_player_open',
		property: 'shorts_popular',
	});
	openModal();
}

function openModal() {
	ReelsExp.trackEvent({
		action: 'impression',
		property: 'shorts_popular',
	});
	ModalHelper.openModal(
		ReelModal,
		{ queryVariables: props.queryVariables, title: props.title.id },
		{ cssClass: 'reel-modal' }
	);
}

return { __sfc: true,setActiveModuleIndex, props, clipUrl, expanded, toggleExpand, collapse, handleClick, openModal, HLSPlayer }
}

})